// theme.js
// Brand tokens for the pre-order / early-bird UI. Components import these
// instead of hardcoding hexes.
export const THEME = {
  bg: "#F5F2EC",
  ink: "#1a1a2e",
  blue: "#2563EB",
  orange: "#EA580C",
  darkOrange: "#993C1D",
  green: "#16A34A",
  grey: "#9CA3AF",
  coral: "#FDF0EC",
  coralBorder: "#F5C4B3",
  fonts: {
    price: "'Fraunces', Georgia, serif",
    body: "'Plus Jakarta Sans', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  radius: 16,
};
